// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { MonedaProps } from '../interfaces'
import { FRAGMENT_MONEDA } from '../interfaces/fragment'

const query = gql`
  ${FRAGMENT_MONEDA}
  query ARTICULO_MONEDA {
    monedaListado {
      ...fields
    }
  }
`

/**
 * Listamos las monedas
 */
export const apiMonedaListado = async (): Promise<MonedaProps[]> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)

    const data: any = await client.request(query)
    return data.monedaListado
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
